import React from 'react';
import { connect } from 'react-redux';
import { goBack } from 'react-router-redux';

const OnboardingBackButton = ({ className, goBack }) => (
  <button className={className} onClick={goBack}>
    &lt; Back
  </button>
);

export default connect(
  null,
  dispatch => ({
    goBack: e => {
      e.preventDefault();
      dispatch(goBack());
    },
  })
)(OnboardingBackButton);
